var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMesas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87242 3.09176L5.94302 3.02317C5.20997 3.01037 4.60535 3.59425 4.59255 4.3273L4.52397 8.2567C4.51117 8.98975 5.09505 9.59437 5.8281 9.60717L9.7575 9.67575C10.4905 9.68855 11.0952 9.10467 11.108 8.37162L11.1766 4.44222C11.1893 3.70918 10.6055 3.10455 9.87242 3.09176Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4868 5.76912L14.5574 5.70054C13.8244 5.68774 13.2197 6.27162 13.2069 7.00467L13.1383 10.9341C13.1256 11.6671 13.7094 12.2717 14.4425 12.2845L18.3719 12.3531C19.1049 12.3659 19.7095 11.782 19.7223 11.049L19.7909 7.11959C19.8037 6.38654 19.2198 5.78192 18.4868 5.76912Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87157 12.1654L5.94217 12.0968C5.20912 12.084 4.6045 12.6679 4.5917 13.4009L4.52311 17.3303C4.51032 18.0634 5.0942 18.668 5.82724 18.6808L9.75664 18.7494C10.4897 18.7622 11.0943 18.1783 11.1071 17.4452L11.1757 13.5158C11.1885 12.7828 10.6046 12.1782 9.87157 12.1654Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4864 14.3928L14.557 14.3242C13.824 14.3114 13.2194 14.8953 13.2066 15.6283L13.138 19.5577C13.1252 20.2908 13.7091 20.8954 14.4421 20.9082L18.3715 20.9768C19.1046 20.9896 19.7092 20.4057 19.722 19.6726L19.7906 15.7432C19.8034 15.0102 19.2195 14.4056 18.4864 14.3928Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMesas);
export default __webpack_public_path__ + "static/media/Ico_mesas.9e7c6b41c12e69c3e60c8fc0eab07ea6.svg";
export { ForwardRef as ReactComponent };